import React from "react";
import StatCard from "../Components/StatCard";
import SectionLabel from "../Components/SectionLabel";
import StatGrid from "../Components/statGrid";

const EnergyTab = ({ energyData = {} }) => {
  return (
    <>
      <div style={{ borderTop: "1px solid #dee2e6", margin: "8px 0 20px" }} />

      {/* ── Energy ── */}
      <SectionLabel>Energy overview</SectionLabel>
      <StatGrid>
        <StatCard
          label="Total energy"
          value={energyData?.totalEnergy}
          sub="All time combined"
          accent="green"
        />
        <StatCard
          label="Total credit"
          value={energyData?.totalEnergyCredit}
          sub="Total energy earned"
          accent="blue"
        />
        <StatCard
          label="Total debit"
          value={energyData?.totalEnergyDebit}
          sub="Total energy spent"
          accent="red"
        />
      </StatGrid>

      <SectionLabel>Energy credit breakdown</SectionLabel>
      <StatGrid>
        <StatCard
          label="From game"
          value={energyData?.totalEnergyCreditWithGame}
          sub="Earned via gameplay"
          accent="teal"
        />
        <StatCard
          label="From buy"
          value={energyData?.totalEnergyCreditWithBuy}
          sub="Purchased energy"
          accent="blue"
        />
        <StatCard
          label="Other sources"
          value={energyData?.totalEnergyCreditWithEtc}
          sub="Miscellaneous credits"
          accent="coral"
        />
      </StatGrid>

      <SectionLabel>Energy purchase channels</SectionLabel>
      <StatGrid>
        <StatCard
          label="Bitanica Pay"
          value={energyData?.totalBuyEnergyCreditWithBitanicaPay}
          sub="Paid via Bitanica Pay"
          accent="purple"
        />
        <StatCard
          label="Card"
          value={energyData?.totalBuyEnergyCreditWithCard}
          sub="Paid via card"
          accent="blue"
        />
        <StatCard
          label="Crypto"
          value={energyData?.totalBuyEnergyCreditWithCrypto}
          sub="Paid via crypto"
          accent="amber"
        />
        <StatCard
          label="BTNC"
          value={energyData?.totalBuyEnergyCreditWithBtnc}
          sub="Paid via BTNC"
          accent="green"
        />
      </StatGrid>
    </>
  );
};

export default EnergyTab;
